import React from 'react'
import { object } from 'prop-types'
import { Box, Heading } from 'rebass'
import LinkRounded from '../../components/LinkRounded'
import {
  LocationCard,
  LocationAddress,
  LocationImage,
  LocationCtaWrapper,
  LocationBrands,
  LocationContent,
  LocationOverlay
} from './components/LocationCardStyled'
import Image from '../Image'
import { withTheme } from 'styled-components'
import brandLogoMapper from '../../../lib/make/brand-logo-mapper'

const ContentDealershipLocationCard = ({ dealership, theme }) => {
  const image =
    (dealership.thumbnailImages && dealership.thumbnailImages[0]) ||
    (dealership.images && dealership.images[0])
  return (
    <LocationCard
      width={[12 / 12, 6 / 12, 4 / 12, 4 / 12]}
      mt={20}
      mb={40}
      flexDirection="column"
    >
      {image && (
        <LocationImage bg={theme.colors.white} mx={18}>
          <Image
            resource={image}
            width="720"
            height="372"
            mode="cover"
            alt={dealership.shortName}
          />
        </LocationImage>
      )}
      <LocationContent bg={theme.colors.white} mx={18} pb={50} px={30}>
        <LocationAddress pt={25} pb={30}>
          <Heading fontSize={4} mb={20} color={theme.colors.blue}>
            {dealership.shortName}
          </Heading>
          {dealership.addressLine1 && <div>{dealership.addressLine1}</div>}
          {dealership.addressLine2 && <div>{dealership.addressLine2}</div>}
          {dealership.addressLine3 && <div>{dealership.addressLine3}</div>}
          {dealership.town && <div>{dealership.town}</div>}
          {dealership.county && <div>{dealership.county}</div>}
          {dealership.postcode && <div>{dealership.postcode}</div>}
        </LocationAddress>
        <LocationCtaWrapper>
          <LinkRounded
            thin
            shadow
            mt={10}
            href={`/locations/${dealership.slug}`}
          >
            View Dealership
          </LinkRounded>
        </LocationCtaWrapper>
        {dealership.vehicles && (
          <LocationBrands mt={40}>
            <Box mx={25} key={`brand:${dealership.vehicles[0].slug}`}>
              {brandLogoMapper(dealership.vehicles[0])}
            </Box>
          </LocationBrands>
        )}
      </LocationContent>
      <LocationOverlay to={`/locations/${dealership.slug}`}>
        View {dealership.shortName}
      </LocationOverlay>
    </LocationCard>
  )
}
ContentDealershipLocationCard.propTypes = {
  dealership: object
}

export default withTheme(ContentDealershipLocationCard)
